import { Strategy3DSOption } from "../../payment-processing/configuration-3ds/Configuration3DSSetup"
import { isError } from "../helpers/Error"
import HttpClient from "../helpers/HttpClient"
import Configuration3DS, { Configuration3DSDto } from "./Configuration3DS"

export type UpdateConfiguration3DSPayload = {
    strategy3DSOption: Strategy3DSOption
    minimumAmountThreshold: number
}

class Configuration3DSService {
    static httpClient = new HttpClient<Configuration3DS, Configuration3DSDto>(Configuration3DS)

    static async get(): Promise<Configuration3DS | Error> {
        const res = await this.httpClient.get("/configuration-3ds")
        if (isError(res)) {
            throw new Error(res.payload.error?.message)
        }
        return res as Configuration3DS
    }

    static async update(payload: UpdateConfiguration3DSPayload): Promise<Configuration3DS | Error> {
        const res = await this.httpClient.patch("/configuration-3ds", payload)
        if (isError(res)) {
            throw new Error(res.payload.error?.message)
        }
        return res as Configuration3DS
    }
}

export default Configuration3DSService



// WEBPACK FOOTER //
// ./src/state/configuration3ds/Configuration3DSService.ts